import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel } from '@angular/router';
import { Globals } from 'src/app/globals';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent  {
    constructor(private route: ActivatedRoute, public router: Router, public globals: Globals, private sanitizer: DomSanitizer) { }   
}